import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../GlobalContext';
import { useParams } from 'react-router-dom';

export default function ClubTeams() {
  const { cid } = useParams();
  const { alert, setLoading } = useContext(GlobalContext);

  const [name, setName] = useState('');
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    setLoading(true);
    (async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/club/teams/${cid}`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('auth'),
        },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        setTeams(data.teams);
        setName(data.club);
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    })()
      .catch((error) => alert({ type: 'danger', title: 'Error !', text: error.message }))
      .finally(() => setLoading(false));
  }, [alert, cid, setLoading]);

  return (
    <div className="page-body">
      <div className="container-xl">
        <div className="card">
          <div className="card-header justify-content-center">
            <h2 className="page-title">{name} Teams</h2>
          </div>
          {teams.map((tm) => (
            <div
              key={tm.sport._id}
              className="list-group-item accordion"
              id={`accordion-${tm.sport._id}`}>
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id={`heading-${tm.sport._id}`}>
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${tm.sport._id}`}
                    aria-expanded="false">
                    {tm.sport.name}
                  </button>
                </h2>
                <div
                  id={`collapse-${tm.sport._id}`}
                  className="accordion-collapse collapse"
                  data-bs-parent={`#accordion-${tm.sport._id}`}>
                  <div className="accordion-body">
                    {tm.players.map((pl) => (
                      <ul
                        key={pl._id}
                        className="list-unstyled lh-lg">
                        <li>Name: {pl.name}</li>
                        <li>Email: {pl.email}</li>
                        <li>Phone: {pl.phone}</li>
                        <li>DOB: {pl.dob}</li>
                        <li>Gender: {pl.gender}</li>
                        <li>Jersey Size: {pl.jerseySize}</li>
                        <li>Blood Group: {pl.bloodGroup}</li>
                      </ul>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
